<template>
  <div>
    <div class="form-group">
      <duration-picker v-model="duration_obj" :seconds="false" :days="false" />
    </div>

    <div class="form-group">
      <label>Available Streams</label>
      <br>
      <button v-for="(stream, index) in streams"
              :key="index"
              :class="{active : selected_stream && selected_stream === stream}"
              type="button" class="btn btn-ss btn-stream-selection"
              @click="selectStream(stream)">
        {{ stream }}
      </button>
    </div>
    <div v-if="selected_stream" class="form-group">
      <button class="btn btn-ss" @click="callRecord()">
        <span class="kt-menu__link-icon">
          <i class="fa fa-record-vinyl" />
          Start Recording
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import DurationPicker from 'VueComponents/DurationPicker';

export default {
  components: {
    DurationPicker,
  },
  data: () => ({
    duration_obj: {
      minutes: window.preferences.quick_record_duration,
    },
    selected_stream: null,
  }),
  computed: {
    duration() {
      return this.durationObjToUnit(this.duration_obj, `minutes`);
    },
    humanDuration() {
      return moment.duration(this.duration, "minutes").format("h [hrs] m [min]");
    },
  },
  asyncComputed: {
    streams: {
      async get() {
        try {
          return (await axios.get(`/api/v1/streams`)).data.data.streams.map(stream => stream.name);
        } catch (err) {
          window.handleAxiosError(err);
          return [];
        }
      },
    },
  },
  methods: {
    selectStream(stream) {
      this.selected_stream = stream;
    },

    record: _.debounce(function (stream) {
      this.callRecord(stream);
    }, 2000),

    async callRecord() {
      const stream = this.selected_stream;
      if (!stream) {
        toastr.error("Please select a stream");
        return;
      }
      try {
        const response = await axios.post('/api/v1/recorder/record', {
          streamname: stream,
          duration: this.duration,
        });
        if (response.data.success) {
          if (response.data.data.data.success) {
            EventBus.$emit("recording_started");
            toastr.success(`Started recording ${this.selected_stream} for ${this.humanDuration}`);
          }
        } else {
          toastr.error(response.data.error.message);
        }
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @use "sass:map";

  @use "~AssetsSass/_variables" as *;

  .btn-stream-selection {
    margin: 0 5px 5px 0;
    &.active {
      background-color: map.get($ss, 'primary');
      font-weight:bold;
      color:#FFF;
    }
  }
</style>
